

exports.__esModule = true;
exports.$SidebarShippingRoute = undefined;

var _squid = require('squid');

require('./directive');

var $SidebarShippingRoute = exports.$SidebarShippingRoute = _squid.$ComponentRoute.extend('$SidebarShippingRoute', {
    path: 'shipping',
    directive: 'xo-shipping',
    titleContent: 'asideHeader.selectShipping',
    trackingData: {
        fptiState: 'select_shipping_address',
        templateName: 'selectShipping.dust',
        pageGoal: 'Select Shipping',
        buzname: {
            'fullpage': {
                'pagename': '%::fullpage-select-shipping-address',
                'pagename2': '%::fullpage-select-shipping-address:member:hermes:',
                'version': 'member:%:'
                // More page qualifiers come here...
            } }
    }
});

angular.value("$SidebarShippingRoute", $SidebarShippingRoute);
_squid.$ComponentRoute;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-shipping/route.js
// module id = ./pages/xo-shipping/route.js
// module chunks = 0